import { Plus } from "lucide-react";
import { Button } from "../ui/button";
import { useState } from "react";

type NewItemDialogTriggerProps = {
  title: string;
  Dialog: (props: {
    open: boolean;
    onOpenChange: (open: boolean) => void;
  }) => JSX.Element;
};

const NewItemDialogTrigger = ({ title, Dialog }: NewItemDialogTriggerProps) => {
  const [newItemDialogOpen, setNewItemDialogOpen] = useState(false);

  return (
    <>
      <Button
        type="button"
        className="flex items-center gap-2"
        onClick={() => setNewItemDialogOpen(true)}
      >
        <Plus size={16} />
        {title}
      </Button>

      <Dialog open={newItemDialogOpen} onOpenChange={setNewItemDialogOpen} />
    </>
  );
};

export default NewItemDialogTrigger;
